import * as imageConversion from 'image-conversion';

/**
 * @description: 压缩图片
 * @param {File} file
 * @param {Number} fileSize
 * @return {File} file
 * @author: lijinpeng
 */
export const imageCompress = (file, fileSize = 500) => {
  return new Promise((resolve, reject) => {
    imageConversion
      .compressAccurately(file, fileSize)
      .then(res => {
        const compressed_file = new File([res], file.name, {
          type: file.type,
          lastModified: Date.now(),
        });
        compressed_file.uid = file.uid;
        return resolve(compressed_file);
      })
      .catch(error => {
        return reject(error);
      });
  });
};
